exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-day-popover-row[data-v-18514c08]{--day-content-transition-time:0.13s ease-in;display:flex;align-items:center;transition:all var(--day-content-transition-time)}.vc-day-popover-row[data-v-18514c08]:not(:first-child){margin-top:3px}.vc-day-popover-row-indicator[data-v-18514c08]{display:flex;justify-content:center;align-items:center;flex-grow:0;width:15px;margin-right:3px}.vc-day-popover-row-indicator span[data-v-18514c08]{transition:all var(--day-content-transition-time)}.vc-day-popover-row-content[data-v-18514c08]{display:flex;align-items:center;flex-wrap:none;flex-grow:1;width:-webkit-max-content;width:max-content}", ""]);

// exports
